<template>
  <div :class="`notification-preview-${language} mb-3`">
    <h3 class="mb-2">{{ language }}</h3>
    <div class="notification-preview-subject d-flex">
      <h4>{{ notification.subject }}</h4>
    </div>
    <div class="notification-preview-body d-flex">{{ notification.body }}</div>
    <div
      v-if="notification.linkUrl"
      class="notification-preview-link-url d-flex"
    >
      <a :href="notification.linkUrl">{{ notification.linkText }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotificationPreview',
    props: {
      language: {
        type: String,
        required: true
      },
      notification: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style>
.notification-preview-body  {
  white-space: pre-line;
}
</style>
